import { render, staticRenderFns } from "./groupaccounts.vue?vue&type=template&id=3fd519d5"
import script from "./groupaccounts.vue?vue&type=script&lang=js"
export * from "./groupaccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports